export default "__VITE_PUBLIC_ASSET__2437408e__"